import { Module } from 'vuex';

type SnackbarData = Partial<{
  show: boolean;
  text: string;
  icon: string;
  /** You can use 'primary', 'success', 'error'... */
  color: string;
  timeout: number;
  bottom: boolean;
  top: boolean;
  left: boolean;
  right: boolean;
  outline: boolean;
  rounded: boolean | string;
  multiLine: boolean;
}>;

const notifications: Module<{ snackbar: SnackbarData }, {}> = {
  state: {
    snackbar: {
      show: false,
      text: '',
      icon: '',
      color: 'primary',
      timeout: 4000,
      bottom: true,
      top: false,
      left: false,
      right: true,
      outline: false,
      rounded: 'lg',
      multiLine: false,
    },
  },

  getters: {
    snackbar(state) {
      return state.snackbar;
    },
  },

  mutations: {
    setSnackbar(state, snackbarData: SnackbarData) {
      state.snackbar = snackbarData;
    },
  },

  actions: {
    updateSnackbar({ commit }, data: SnackbarData) {
      console.log('setSnackbar', data);
      commit('setSnackbar', data);
    },
  },
};

export default notifications;
